"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Button = _interopRequireDefault(require("../global/components/Button"));

var _react = _interopRequireDefault(require("react"));

var _CustomHR = _interopRequireDefault(require("./CustomHR"));

var _ReceiptFailedModule = _interopRequireDefault(require("./ReceiptFailed.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules
// Styles
var ReceiptFailed = function ReceiptFailed(props) {
  var sentTo = props.sentTo,
      retryReceipt = props.retryReceipt,
      cancelReceipt = props.cancelReceipt;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _ReceiptFailedModule.default.container
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: _ReceiptFailedModule.default.header
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: _ReceiptFailedModule.default.crossmark
  }, "\u2716"), /*#__PURE__*/_react.default.createElement("h3", null, "Error sending receipt")), /*#__PURE__*/_react.default.createElement(_CustomHR.default, null), /*#__PURE__*/_react.default.createElement("p", null, "Receipt could not be sent to: ", sentTo), /*#__PURE__*/_react.default.createElement(_Button.default, {
    clickHandler: retryReceipt,
    text: "Try again",
    extraStyles: {
      marginBottom: '2rem'
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    clickHandler: cancelReceipt,
    text: "Cancel",
    variant: "gray",
    extraStyles: {
      marginBottom: '2rem'
    }
  }));
};

var _default = ReceiptFailed;
exports.default = _default;